//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Message,Loading } from "element-ui";
import { update, verifyReset, sendCode } from "../comon/api/home";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
        if (this.newpasswd === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.checkpasswd !== '') {
            this.$refs.resetForm.validateField('checkpasswd');
          }
          callback();
        }
      };
    let validatePass2 = (rule, value, callback) => {
      if (this.checkpasswd === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.checkpasswd !== this.newpasswd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      step: 1,
      sending: false,
      startsend: false,
      loading:false,
      vcodeBtnTxt: "获取验证码",
      toLoginBtn: '返回登录页',
      timer: null,   
      checkrules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请填写手机号码", trigger: "blur" }
          // { type:'phone', message: '请填写正确手机号码', trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, message: "请填写手机验证码", trigger: "blur" }
        ]
      },
      checkForm: {
        username: "",
        phone: "",
        verifyCode: ""
      },
      resetrules: {
        newpasswd: [{ validator: validatePass, trigger: 'blur' }],
        checkpasswd: [{ validator: validatePass2, trigger: "blur" }]
      },
      resetForm: {},
      newpasswd: "",
      checkpasswd: ""
    };
  },
  created() {},
  methods: {
    jumplogin(){
      this.$router.replace({path: '/login'})
    },
    nextStep() {
      if (this.step < 3) this.step++;
    },
    prevStep() {
      console.log(this.step);
      if (this.step > 1) this.step--;
    },
    // 倒计时
    countdown(time){
        clearTimeout(this.timer);
        if(time>0){
          // time--;
          this.vcodeBtnTxt = --time+"S后重新获取"
          this.timer = setTimeout(()=>{
            this.countdown(time)
          },1000)
        }else{
          this.sending = false;
          this.vcodeBtnTxt = "获取验证码"
        }
    },
    // 倒计时
    countdownToLogin(time){
        if(time>0){
          time--;
          this.toLoginBtn = time+"S后自动跳转登录页面"
          setTimeout(()=>{
            this.countdownToLogin(time)
          },1000)
        }else{
           this.jumplogin();
        }
    },
    // 发送验证码
    sendPhoneCode() {
      this.checkrules.verifyCode[0].required = false;
      this.startsend = true;
      this.$refs["checkForm"].validate(valid => {
        if (valid) {
          sendCode({
            phone: this.checkForm.phone,
          })
            .then(res => {
              console.log(res);
              if (res.code == 200) {
                this.sending = true;
                this.startsend = false;
                this.countdown(60);
              } else {
                this.startsend = false;
              }
            })
            .catch(err => {
              console.log(err);
            });
        }else{
                this.startsend = false;
        }
      });
    },
    getverifyCode(){
       this.checkrules.verifyCode[0].required = true;
       this.$refs["checkForm"].validate(valid => {
        if (valid) {
          this.nextStep();
        }
      });
    },
    // 提交新密码
    submit() {
      this.$refs["resetForm"].validate(valid => {
        if (valid) {
          this.loading = true
          verifyReset({
            password: this.newpasswd,
            phone: this.checkForm.phone,
            username: this.checkForm.username,
            code: this.checkForm.verifyCode
          })
            .then(res => {
              console.log(res)
              if (res.code == 200) {
                this.step = 3;
                this.countdownToLogin(5);
                this.loading = false
              } else {
                this.$message({
                  showClose: true,
                  message: '验证码、用户名或手机号码输入错误',
                  type: 'error'
                });
                this. prevStep();
                this.loading = false
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/ForgetPwd.vue